import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  RSelect,
  Row,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { BILL_STATUS, LOCATION, PN_TRANSPORT_BILL_STATUS, TRUCK_TYPE, renderPageStyle } from "../../utils/Utils";

import { useHistory, useLocation } from "react-router-dom";
import Table from "../../components/react-table/Table";
import { getToken } from "../../helper/auth";


const LOCATION_OPTIONS = Object.keys(LOCATION).map((c) => ({
  label: LOCATION[c],
  value: c,
}));

const PN_TRANSPORT_BILL_STATUS_OPTIONS = Object.keys(PN_TRANSPORT_BILL_STATUS).map((c) => ({
  label: PN_TRANSPORT_BILL_STATUS[c],
  value: c,
}));


const PNReportDriverBonus = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [total, setTotal] = useState(0);
  const [updatedAt, setUpdatedAt] = useState();
  const [driverOptions, setDriverOptions] = useState([]);
  const [smOption, setSmOption] = useState(false);
  const [truckOptions, setTruckOptions] = useState([]);
  const [fromLocationOptions, setFromLocationOptions] = useState([]);
  const [toLocationOptions, setToLocationOptions] = useState([]);
  const [pnCustomerOptions, setPnCustomerOptions] = useState([]);

  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    customerId: searchParams.get('customerId') || undefined,
    truckId: searchParams.get('truckId') || undefined,
    driverId: searchParams.get('driverId') || undefined,
    location: searchParams.get('location') || undefined,
    status: searchParams.get('status') || undefined,
    fromLocation: searchParams.get('fromLocation') || undefined,
    toLocation: searchParams.get('toLocation') || undefined,
    customerId: searchParams.get('customerId') || undefined,
  });

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  useEffect(() => {
    GET("/pn-new-customer-money-flow/find-all-with-balance", {
      type: "OUT"
    }, true).then((resp) => {
      const { data } = resp;
      setPnCustomerOptions(
        data.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/user/list-drivers", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setDriverOptions(
          data.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET("truck", {
      type: TRUCK_TYPE.TRUCK

    }, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });


    GET("/location-distance", {}, true).then((resp) => {
      const { data } = resp;
      const fromObj = {};
      const toObj = {};
      data.forEach((c) => {
        fromObj[c.fromLocation] = {
          fromLocation: c.fromLocation,
          fromLocationName: c.fromLocationName || c.fromLocation,
        };
        toObj[c.toLocation] = {
          toLocation: c.toLocation,
          toLocationName: c.toLocationName || c.toLocation,
        };
      });
      setFromLocationOptions(Object.values(fromObj).map((c) => ({
        label: c.fromLocationName,
        value: c.fromLocation,
        data: c,
      })));
      setToLocationOptions(Object.values(toObj).map((c) => ({
        label: c.toLocationName,
        value: c.toLocation,
        data: c,
      })));
    });

  }, [])

  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.location ? { location: filter.location } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.driverId ? { driverId: filter.driverId } : {}),
      ...(filter.status ? { status: filter.status } : {}),
      ...(filter.fromLocation ? { fromLocation: filter.fromLocation } : {}),
      ...(filter.toLocation ? { toLocation: filter.toLocation } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const params = {
      fromDate: moment(rangeDate.start).format('YYYY-MM-DD'),
      toDate: moment(rangeDate.end).format('YYYY-MM-DD'),
    }

    if (filter.customerId) {
      params.customerId = filter.customerId;
    }

    if (filter.location) {
      params.location = filter.location;
    }

    if (filter.truckId) {
      params.truckId = filter.truckId;
    }

    if (filter.driverId) {
      params.driverId = filter.driverId;
    }

    if (filter.status) {
      params.status = filter.status;
    }

    if (filter.fromLocation) {
      params.fromLocation = filter.fromLocation;
    }

    if (filter.toLocation) {
      params.toLocation = filter.toLocation;
    }

    if (filter.customerId) {
      params.customerId = filter.customerId;
    }

    GET(
      `/pn-bill/report-driver-bonus`,
      params,
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data.bills);
      setSummary(data.summary);
      setTotal(data.total)
    });
  }, [updatedAt, filter]);


  const colTable = [

    {
      Header: "Ngày",
      accessor: (item) => moment(item.createdAt).format("DD-MM-YYYY"),
    },
    {
      Header: "Mã đơn",
      accessor: (item) => item.id
    },
    {
      Header: "KH/NCC",
      accessor: (item) => item.customer?.name,
    },
    {
      Header: "Điểm đi",
      accessor: (item) => item.fromLocationName,
    },
    {
      Header: "Điểm đến",
      accessor: (item) => item.toLocationName,
    },

    {
      Header: "Địa điểm",
      accessor: (item) => item.locationName,
    },
    {
      Header: "Biển số xe",
      accessor: (item) => item.truckId,
    },
    {
      Header: "Tài xế",
      accessor: (item) => item.driver?.name,
    },
    {
      Header: "Đơn giá(đ)",
      sortable: true,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.unitPrice}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Số lượng(kg)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.finalMerchandiseWeight || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Doanh thu(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.totalAmount}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tiền tài(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.driverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tiền tài phụ(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.subDriverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Trạng thái",
      accessor: (item) => BILL_STATUS[item.status],
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note,
    },
    // {
    //   Header: "Hành động",
    //   className: 'action-col',
    //   accessor: (item) => (
    //     <ul className="nk-tb-actions gx-1">
    //       <li>
    //         <UncontrolledDropdown>
    //           <DropdownToggle
    //             tag="a"
    //             className="btn btn-icon dropdown-toggle btn-trigger"
    //           >
    //             <Icon name="more-h"></Icon>
    //           </DropdownToggle>
    //           <DropdownMenu right>
    //             <ul className="link-list-opt no-bdr">
    //               <li>
    //                 <DropdownItem
    //                   tag="a"
    //                   href="#edit"
    //                   onClick={(ev) => {
    //                     ev.preventDefault();
    //                     history.push(`/pn/bill/${item.id}`)
    //                     // if (INGREDIENT_GROUP.INGREDIENT === item.ingredient?.group) {
    //                     //   history.push(`/pn/bill/${item.id}`)
    //                     // } else if (INGREDIENT_GROUP.EXTERNAL_PORT_FEE === item.ingredient?.group) {
    //                     //   history.push(`/pn/bill-external-port-fee/${item.id}`)
    //                     // } else if (INGREDIENT_GROUP.OTHER === item.ingredient?.group) {
    //                     //   history.push(`/pn/bill-other/${item.id}`)
    //                     // } else if ([INGREDIENT_GROUP.STAFF, INGREDIENT_GROUP.STAFF_OUT].includes(item.ingredient?.group)) {
    //                     //   history.push(`/pn/bill-staff-money-flow/${item.id}`)
    //                     // }
    //                   }}
    //                 >
    //                   <Icon
    //                     name={"edit"}
    //                   ></Icon>
    //                   <span>
    //                     {"Cập nhật"}
    //                   </span>
    //                 </DropdownItem>
    //               </li>
    //             </ul>
    //           </DropdownMenu>
    //         </UncontrolledDropdown>
    //       </li>
    //     </ul>
    //   ),
    // },

  ];


  const colTableSummary = [
    {
      Header: "Tài xế",
      accessor: (item) => item.name,
    },
    {
      Header: "Xe",
      accessor: (item) => [...new Set(item.truckIds)].join(", "),
    },
    {
      Header: "Số chuyến",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.countBill}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tổng Tiền tài(đ)",
      sortable: true,
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.amount}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      fromDate: moment(rangeDate.start).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.end).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.driverId ? { driverId: filter.driverId } : {}),
      ...(filter.location ? { location: filter.location } : {}),
      ...(filter.status ? { status: filter.status } : {}),
      ...(filter.fromLocation ? { fromLocation: filter.fromLocation } : {}),
      ...(filter.toLocation ? { toLocation: filter.toLocation } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn-bill/report-driver-bonus-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap" >
                        <DatePicker
                          placeholder="Thời gian"
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          onChange={onRangeChange}
                          endDate={rangeDate.end}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <RSelect
                          isClearable
                          placeholder="Biển số xe"
                          options={truckOptions}
                          value={
                            truckOptions.find(
                              (c) => c.value == filter.truckId
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              truckId: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <RSelect
                          isClearable
                          placeholder="Địa điểm"
                          options={LOCATION_OPTIONS}
                          value={
                            LOCATION_OPTIONS.find(
                              (c) => c.value == filter.location
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              location: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <RSelect
                          isClearable
                          placeholder="Trạng thái"
                          options={PN_TRANSPORT_BILL_STATUS_OPTIONS}
                          value={PN_TRANSPORT_BILL_STATUS_OPTIONS.find((c) => c.value === filter.status)}
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              status: val?.value || undefined,
                            })
                          }}
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <RSelect
                          isClearable
                          placeholder="Điểm đi"
                          options={fromLocationOptions}
                          value={
                            fromLocationOptions.find(
                              (c) => c.value === filter.fromLocation
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              fromLocation: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <RSelect
                          isClearable
                          placeholder="Điểm đến"
                          options={toLocationOptions}
                          value={
                            toLocationOptions.find(
                              (c) => c.value === filter.toLocation
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              toLocation: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <RSelect
                          isClearable
                          placeholder="KH/NCC"
                          options={pnCustomerOptions}
                          value={
                            pnCustomerOptions.find(
                              (c) => c.value === filter.customerId
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              customerId: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap">
                        <RSelect
                          isClearable
                          placeholder="Tài xế"
                          options={driverOptions}
                          value={driverOptions.find((c) => +c.value === +filter.driverId)}
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              driverId: val?.value || undefined
                            })
                          }}
                        />
                      </div>
                    </li>

                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>


                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="row justify-between g-2">
              <div className="col-8 col-sm-6 text-start"></div>
              <div className="col-5 col-sm-6 text-end">
                <div className="datatable-filter">
                  <div className="d-flex justify-content-end g-2">
                    <div
                      className="dataTables_length"
                      id="DataTables_Table_1_length"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <Row>
                <Col md={12}>
                  <div ref={printRef}>
                    <style>{renderPageStyle()}</style>
                    <style>{`
                      @media print {
                        .table-transport {
                          td.action-col, th.action-col {
                            display: none;
                          }
                        }
                      }
                    `}</style>
                    <h4 className='w-100 text-center'>Danh sách vận chuyển và tiền tài</h4>
                    <div className="table-transport">
                      <Table
                        columns={colTable}
                        data={data}
                        notShowPagi={true}
                        onRowDoubleClick={(item) => {
                          history.push(`/pn/bill/${item.id}`)
                        }}
                        headerRow={<tr className="font-weight-bold">
                          <td colSpan={9}>
                            Tổng: {summary?.count} đơn
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary?.finalMerchandiseWeight || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary?.totalAmount || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary?.driverBonus || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary?.subDriverBonus || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        }
                      ></Table>
                    </div>


                    <Row>
                      <Col md={12} col={12}>
                        <h4 className='mt-3 w-100 text-center'>Lương tài xế</h4>
                        <Table
                          columns={colTableSummary}
                          data={
                            summary?.driver ? Object.values(summary.driver) : []
                          }
                          notShowPagi={true}
                          headerRow={<tr className="font-weight-bold">
                            <td colSpan={3}>
                              Tổng cộng
                            </td>
                            <td className=" text-right">
                              <NumericFormat
                                displayType={"text"}
                                value={total || 0}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                              />
                            </td>
                          </tr>}
                        ></Table>
                      </Col>
                    </Row>

                  </div>
                </Col>
              </Row>
            </div>
          </div>

        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNReportDriverBonus;
